import { createContainer } from '@dbk-legacy/muster/react';
import AssetHeader from './index';
import merge from 'lodash/merge';

export const defaultAssetDataFragment = {
  marketValue: true,
  dayChange: {
    value: true,
    percentage: true,
  },
};

export const defaultDataMapper = ({ assetData }) => {
  const { dayChange, ...rest } = assetData;

  return {
    dayChangeValue: dayChange.value || null,
    dayChangePercent: dayChange.percentage,
    ...rest,
  };
};

export function factory({
  component = AssetHeader,
  assetDataFragment = defaultAssetDataFragment,
  assetDataFragmentExtend,
  mapper = defaultDataMapper,
  mapperExtend,
} = {}) {
  let resultingAssetDataFragment = assetDataFragment;

  if (assetDataFragmentExtend) {
    resultingAssetDataFragment = merge({}, resultingAssetDataFragment, assetDataFragmentExtend);
  }

  let resultingMapper = mapper;

  if (mapperExtend) {
    resultingMapper = data => merge(mapper(data), mapperExtend(data));
  }

  return createContainer({
    $fragments: {
      assetData: resultingAssetDataFragment,
    },
  }, resultingMapper)(component);
}

export default factory();
